import { Div, Text } from "atomize"
import { theme } from "../settings/config"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUsers } from "@fortawesome/free-solid-svg-icons"
import { Fragment, useContext } from "react"
import { schoolContext } from "../providers/school.provider"
import { profileContext } from "../providers/profile.provider"
import { sharedDataContext } from "../providers/sharedData.provider"
import { getSportIcon, lessonTypeHasCourt } from "../utils/func.utils"
import {
	BILLED_TO_SCHOOL,
	COURT_PAID_BY_COACH,
	formatAmount,
	getCourtFeeAtDate,
	getLessonBilledTo,
	getSchoolRates,
	isAssistantIn,
	isCourtPaidByPlayers,
} from "../utils/billing.utils"
import CourtBlock from "./CourtBlock"

function LessonFooter({ lessonData }) {
	const { getSelectedSchool, getSchoolSettings } = useContext(schoolContext)
	const { coach } = useContext(profileContext)
	const { getLessonType } = useContext(sharedDataContext)

	const school = getSelectedSchool()
	const court = lessonData.court
	// le lezioni vecchie salvavano il numero e basta, senza sport né superficie
	const courtNumber = court?.courtNumber ?? court
	const courtsSport = court?.courtsSport ?? lessonData.sportID
	const hasCourt = court && school && lessonTypeHasCourt(getLessonType(lessonData.lessonType))

	const settings = getSchoolSettings()
	const courtFee = getCourtFeeAtDate(
		settings?.courtsFee,
		lessonData.sportID,
		{ usingLights: lessonData.usingLights, usingHeat: lessonData.usingHeat },
		lessonData.lessonStart,
	)

	// Chi ha pagato il campo si dice dove vuol dire qualcosa: in una lezione
	// fatturata al circolo il campo non è di nessuno dei due, e dove non c'è
	// una tariffa il campo pagato da te non è una notizia — è come è sempre
	// stato.
	const billedToSchool =
		getLessonBilledTo(lessonData, getSchoolRates(coach?.billingData, lessonData.schoolID)) ===
		BILLED_TO_SCHOOL
	const courtPaidBy = lessonData.courtPaidBy ?? COURT_PAID_BY_COACH
	// il campo è del titolare: a chi lo assiste non dice niente
	const showsPayer =
		!billedToSchool &&
		!isAssistantIn(lessonData, coach?.coachID) &&
		(courtFee !== null || isCourtPaidByPlayers(lessonData.courtPaidBy))

	const assistantCoachIDs = Array.isArray(lessonData.assistantCoachIDs)
		? lessonData.assistantCoachIDs
		: []
	// chi guarda è "Tu", da titolare o da assistente
	const firstNameOf = coachID =>
		coachID === coach?.coachID
			? "Tu"
			: school?.coaches?.[coachID]?.coachName?.split(" ")[0]

	return (
		<Div d="flex" justify="space-between" align="center" m={{ b: "0.25rem" }}>
			{hasCourt && (
				// sul telefono vola nella riga della settimana (vedi MorphingLesson)
				<div data-morph="court" style={{ display: "flex" }}>
					<CourtBlock
						courtNumber={courtNumber}
						surfaceColor={theme.colors[school.courts[courtsSport]?.[courtNumber]?.surfaceType]}
						sportIcon={lessonData.sportID === "atletica" ? getSportIcon(courtsSport) : null}
						usingLights={lessonData.usingLights}
						usingHeat={lessonData.usingHeat}
						courtPaidBy={showsPayer ? courtPaidBy : null}
						money={showsPayer && courtFee !== null ? `${formatAmount(courtFee)} €/h` : null}
						bg={theme.colors.background}
						expandable={false}
						fitContent
						m="0"
					/>
				</div>
			)}
			{assistantCoachIDs.length > 0 && (
				<Div
					d="flex"
					w="fit-content"
					align="center"
					style={{ gap: "0.25rem" }}
					p="0.25rem 0.5rem"
					m={{ l: "1rem" }}
					rounded="15px"
					bg={theme.colors.background}>
					<FontAwesomeIcon icon={faUsers} />
					<Text>
						{firstNameOf(lessonData.coachID)}
						{assistantCoachIDs.map(assistantCoachID => (
							<Fragment key={assistantCoachID}>
								{", "}
								{firstNameOf(assistantCoachID)}
							</Fragment>
						))}
					</Text>
				</Div>
			)}
		</Div>
	)
}

export default LessonFooter
